import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Dashboard } from '../components'

import { State } from '../reducers'
import { getOverview } from '../actions/performance'
import { PerformanceStore } from '../typings/stores/PerformanceStore'
import { getRecentSales } from '../actions/recentSales'
import { RecentSalesStore } from '../typings/stores/RecentSalesStore'
import { getAlerts } from '../actions/old/alerts'
import { AlertsStore } from '../typings/stores/old/AlertsStore'
import { DateRange } from '../typings/dates'
import { Website } from '../typings/website'
import { convertPeriodToDates } from '../utils/dates'

interface DashboardProps {
  activeWebsite: Website
  performance?: PerformanceStore
  recentSales?: RecentSalesStore
  alerts?: AlertsStore
  getPerformanceOverview(dateRange?: DateRange): void
  getRecentSales(): void
  getAlerts(): void
}

class DashboardContainer extends Component<DashboardProps> {
  state = {
    dateRange: {
      period: 'last_week',
    },
  }

  componentDidMount = () => {
    const dateRange = convertPeriodToDates(this.state.dateRange.period)

    this.props.getRecentSales()
    this.props.getAlerts()
    this.props.getPerformanceOverview(dateRange)
    this.setState({
      dateRange,
    })
  }

  componentDidUpdate = prevProps => {
    const { performance, activeWebsite } = this.props
    const { dateRange } = this.state

    if (prevProps.performance.filters !== performance.filters) {
      this.setState({
        dateRange: performance.filters,
      })
    }

    if (prevProps.activeWebsite.id !== activeWebsite.id) {
      this.props.getRecentSales()
      this.props.getAlerts()
      this.props.getPerformanceOverview(dateRange)
    }
  }

  render = () => {
    const {
      performance,
      recentSales,
      alerts,
      getPerformanceOverview,
    } = this.props

    return (
      <Dashboard
        handleFilterChange={getPerformanceOverview}
        performance={performance}
        recentSales={recentSales}
        alerts={alerts}
      />
    )
  }
}

const mapStateToProps = (state: State) => ({
  performance: state.performance,
  recentSales: state.recentSales,
  alerts: state.alerts,
  activeWebsite: state.user.activeWebsite,
})

const mapDispatchToProps = dispatch => ({
  getPerformanceOverview: (dateRange?: DateRange) =>
    dispatch(getOverview(dateRange)),
  getRecentSales: () => dispatch(getRecentSales()),
  getAlerts: () => dispatch(getAlerts({})),
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer)
